// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Affichage des boutons */
.btnContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnGenerationEtiquette {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  margin-left: 2rem;
  margin-right: 2rem;
  width: 150px;
  height: 50px;
  background-color: black;
  color: white;
  border-color: white;
  box-shadow: 0px 2px 5px grey;
  font-size: 18px;
  border-radius: 15px;
  cursor: pointer;
}

.btnGenerationEtiquette:hover {
  background-color: white;
  color: black;
  border-color: black;
}

/* Affichage du visuel de l'étiquette */
.EtiquetteSelected {
  margin-top: 2rem;
  margin-bottom: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* Affichage de l'étiquette en version imprimable */
@media print {
  @page {
    size: A4 landscape;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .no-print {
    display: none;
  }
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Ticketing.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE;IACE,kBAAkB;EACpB;EACA;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":["/* Affichage des boutons */\n.btnContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.btnGenerationEtiquette {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2rem;\n  margin-left: 2rem;\n  margin-right: 2rem;\n  width: 150px;\n  height: 50px;\n  background-color: black;\n  color: white;\n  border-color: white;\n  box-shadow: 0px 2px 5px grey;\n  font-size: 18px;\n  border-radius: 15px;\n  cursor: pointer;\n}\n\n.btnGenerationEtiquette:hover {\n  background-color: white;\n  color: black;\n  border-color: black;\n}\n\n/* Affichage du visuel de l'étiquette */\n.EtiquetteSelected {\n  margin-top: 2rem;\n  margin-bottom: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n/* Affichage de l'étiquette en version imprimable */\n@media print {\n  @page {\n    size: A4 landscape;\n  }\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n  .no-print {\n    display: none;\n  }\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
